import axios from "axios";
import { config } from "../../../config";

//Report Designer Files/URLs

export const Kendo_Ui_License_URL = () => config.baseURL + "/js/kendo-ui-license.js";
export const WebReportDesigner_URL = () => config.baseURL + "/ReportDesigner/js/webReportDesigner-16.2.22.1109.js";
export const TelerikReportViewer_URL = () => config.baseURL + "/ReportViewer/js/telerikReportViewer-16.2.22.1109.js";
export const ReportDesigner_SERVICE_URL = () => config.baseURL + "/api/v1/reportingdesigner/";
export const Jquery_URL = () => config.baseURL + "/js/jquery.min.js";
export const Kendo_Ui_URL = () => config.baseURL + "/ReportDesigner/js/webReportDesigner.kendo.min.js";

//Report Viewer Files/URLs
export const TelerikReporting_SERVICE_URL = () => config.baseURL + "/api/v1/reporting/";

class ReportingDataService {

}

export const getAllReport = (folder, isAdmin?) => {
    if (isAdmin) {
        return axios.get('api/v1/reportingdesigner/admin/reports/folders/contents?uri=' + folder + '/Published/');
    } else {
        return axios.get('api/v1/reportingdesigner/reports/folders/contents?uri=' + folder + '/Published/');

    }
}

export const downloadReports = () => {
    return axios.get('api/v1/reportingdesigner/reports/file?uri=Draft');
}

export const getAllReportFile = (isAdmin?) => {
    if (isAdmin) {
        return axios.get('api/v1/reportingdesigner/admin/reports/folders/contents?uri=');
    } else {
        return axios.get('api/v1/reportingdesigner/reports/folders/contents?uri=');
    }
}

// Report Search APIS Start
export const getReportSearchesByReport = (reportId) => {
    return axios.get(`api/reporting/${reportId}/Report`);
}

export const DeleteReportSearch = (reportSearchId) => {
    return axios.delete(`/api/reporting/search/${reportSearchId}`);
}

export const PatchReportSearch = (searchId, ifpinned) => {
    return axios.patch(`api/reporting/search/${searchId}`, { pinned: ifpinned });
}

export const UpdateReportSearch = (data) => {
    return axios.put("api/reporting/search", JSON.stringify(data));
}

export const PostReportSearch = (data) => {
    return axios.post("api/reporting/search", JSON.stringify(data));
}
// Report Search APIS END

export default new ReportingDataService();